<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <wz-bar />
    <div id="map" class="map"></div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
// 背景
const wzBar = () => import("../../page/wzBar");
import L from "leaflet";
import cDetail from "../util/detail";
import changeMap from "../util/changeMap";
import { getMMLZDPZHWL } from "@/api/map";
import { mapGetters } from "vuex";
export default {
  components: {
    cDetail,
    wzBar
  },
  computed: {
    ...mapGetters(["layerComponent"])
  },
  watch: {
    layerComponent(val) {
      this.pointChoose(val);
    }
  },
  data() {
    return {
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      kjArr: [],
      zhwlArr: [],
      ydArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      baseList: [],
      zhwlList: [],
      hoverArr: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [20, 50],
      baseAnchor: [10, 50],
      djd: [10, 50],
      ydAnchor: [10, 40],
      ydtAnchor: [10, 40],
      ydwAnchor: [10, 55],
      mianArr: []
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      var url = require("images/map/dt1.png");
      var map = L.map("map", {
        minZoom: 17,
        maxZoom: 20,
        center: [-0.00200653076171875, 0.0021896362304687],
        zoom: 17,
        crs: L.CRS.Simple,
        attributionControl: false
      });
      this.map = map; //data上需要挂载
      window.map = map;
      var northEast = this.map.unproject([2271, 0], this.map.getMaxZoom() - 1); //东北 右上角northEast
      var southWest = this.map.unproject([0, 2406], this.map.getMaxZoom() - 1); //西南 左下角southWest
      var bounds = new L.LatLngBounds(southWest, northEast);
      L.imageOverlay(url, bounds, { interactive: false }).addTo(map);
      // map.setMaxBounds(bounds);//设置了地图和图片一样大小，取消之后，自定义地图可以随意拖拽
      this.dataLoad();
      this.nowZoom = this.map.getZoom();
      map.on("click", e => {
        console.log(e.latlng);
      });
      map.on("zoom", () => {
        if (this.map.getZoom() === 17) {
          this.pointAnchor = [20, 50];
          this.baseAnchor = [10, 50];
          this.djd = [10, 50];
          this.ydAnchor = [10, 40];
          this.ydtAnchor = [10, 40];
          this.ydwAnchor = [10, 55];
        } else if (this.map.getZoom() === 18) {
          this.pointAnchor = [20, 50];
          this.baseAnchor = [5, 55];
          this.djd = [10, 90];
          this.ydAnchor = [10, 50];
          this.ydtAnchor = [0, 50];
          this.ydwAnchor = [0, 60];
        } else if (this.map.getZoom() === 19) {
          this.pointAnchor = [20, 102];
          this.baseAnchor = [-10, 70];
          this.djd = [30, 160];
          this.ydAnchor = [10, 100];
          this.ydtAnchor = [-10, 100];
          this.ydwAnchor = [-20, 100];
        } else {
          this.djd = [50, 300];
          this.pointAnchor = [35, 150];
          this.baseAnchor = [-17, 90];
          this.ydAnchor = [10, 130];
          this.ydtAnchor = [-20, 130];
          this.ydwAnchor = [-60, 130];
        }

        this.beltLoad();
        this.baseLoad();
        this.areaLoad1();
        this.pointLoad();
      });
    },
    //加载标记点数据
    dataLoad() {
      let data = {
        code: 200,
        data: [
          {
            img: "zxd.png",
            code: "0201",
            tc_request_url: "1",
            latitude: "21.79034283273087",
            tc_color: null,
            tc_pic: "zxd",
            tc_name: "世界荔乡科创中心",
            type: "point",
            tc_template: "companyDrawer",
            tc_status: 2,
            grade: 3,
            tc_leftRight: "right",
            name: "世界荔乡科创中心",
            tc_type: "point",
            tc_id: "79ac212440584f5fb2d1e2f166a5afdb",
            tc_quote_template: "companyDrawer",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">位于根子镇。充分利用根子镇作为省级荔枝专业创新示范镇的政策平台优势及茂名市荔枝国家现代农业产业园及高州市荔枝省级现代农业产业园的建设发展基础，依托国家荔枝种质资源圃、中国荔枝博览馆等，切实增强园区的集聚力、辐射力和带动力，围绕荔枝全产业链对科创发展的需求，成立中国荔枝产业研究院，共同搭建现代荔枝产业科技创新中心，全面开展产业技术创新升级和示范推广，成为产业持续发展驱动核，全面推进产业提档升级。引导以茂名荔枝为主导的特色农产品展示、商贸、仓储、加工等集聚发展，不断壮大产业集群规模，着力拓展荔枝加工业、电商物流业、生态旅游业等发展空间，拉长产业链条，推动产业深度融合。</span></p>',
            longitude: "111.09557186239743"
          },
          {
            area: 300,
            code: "0604",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">在河头镇建设生猪良种繁育示范基地，收集引进种猪优秀个体，开展保种繁育、提纯复壮、选育提高等，对新建猪舍装备全自动喂料、全自动温控、自动消毒，数字化管理、种猪生产性能电子测定系统等先进装备系统，大幅度提高猪场综合生产能力，减少和预防疾病，逐步建成国内一流的标准化、数字化、自动化、机械化的规模种猪繁育基地。</span></p>',
            grade: 3,
            img: "ico_sf",
            latitude: "21.83034283273087",
            longitude: "111.06557186239743",
            name: "荔枝标准化种植示范基地",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地：荔枝标准化种植示范基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point"
          },
          {
            area: 300,
            code: "0605",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">在河头镇建设生猪良种繁育示范基地，收集引进种猪优秀个体，开展保种繁育、提纯复壮、选育提高等，对新建猪舍装备全自动喂料、全自动温控、自动消毒，数字化管理、种猪生产性能电子测定系统等先进装备系统，大幅度提高猪场综合生产能力，减少和预防疾病，逐步建成国内一流的标准化、数字化、自动化、机械化的规模种猪繁育基地。</span></p>',
            grade: 3,
            img: "ico_sf",
            latitude: "21.76034283273087",
            longitude: "110.95557186239743",
            name: "高效果蔬冷链物流基地",
            tc_color: "#f3e80c",
            tc_id: "ca1a3c8c2aa943fa88236f091794aa8f",
            tc_leftRight: "1",
            tc_name: "多基地：高效果蔬冷链物流基地",
            tc_pic: "ico_sf",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "point"
          },
          {
            area: 211,
            code: "0302",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">位于根子镇、分界镇。依托根子镇省级荔枝专业创新示范镇和分界镇世华工业区平台，利用当地荔枝初加工深厚产业基础、企业集聚和技术积累优势，引进高效适用的荔枝初加工工艺和设备，推进荔枝初加工产业标准化、现代化、高质量发展。</span></p>',
            grade: 3,
            img: "ico_line",
            latitude: "21.75034283273087",
            longitude: "111.01557186239743",
            name: "荔枝标准化初加工集聚区",
            tc_color: null,
            tc_id: "c70e3ca4473d4d73b03566515889d84d",
            tc_leftRight: "left",
            tc_name: "三区：荔枝标准化初加工集聚区",
            tc_pic: "jd.png",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "polygon"
          },
          {
            area: 211,
            code: "0302",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">位于水东街道。借助电白省级农产品加工示范园平台，通过招商引资、改造重组、联营联合等形式，培育壮大一批联结荔枝生产基地的加工型龙头企业，鼓励和支持科研机构、高等院校和荔枝生产经营主体依托园区优势条件，联合建立科技创新与成果转化机制，着力荔枝精深加工产品的研发、生产、创新，推进荔枝产业链延伸和价值链提升。</span></p>',
            grade: 3,
            img: "ico_line",
            latitude: "21.50034283273087",
            longitude: "111.02557186239743",
            name: "荔枝精深加工创新发展区",
            tc_color: null,
            tc_id: "c70e3ca4473d4d73b03566515889d84d",
            tc_leftRight: "left",
            tc_name: "三区：荔枝精深加工创新发展区",
            tc_pic: "jd.png",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "polygon"
          },
          {
            area: 211,
            code: "0302",
            config: null,
            desc:
              '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">位于产业园全域内，利用园区自然条件禀赋及种植区域集中连片优势，围绕荔枝生产基地扩面提质增效，以调整结构、绿色增产、节水高效、智慧精准为导向，大力推进优质荔枝生产基地建设，以增强优质鲜果生产能力，从源头抓好果品供应，促进产业园及当地荔枝生产方式转变，建设世界最大的优质荔枝生产基地。</span></p>',
            grade: 3,
            img: "ico_line",
            latitude: "21.58034283273087",
            longitude: "111.20557186239743",
            name: "万亩优质荔枝绿色生产区",
            tc_color: null,
            tc_id: "c70e3ca4473d4d73b03566515889d84d",
            tc_leftRight: "right",
            tc_name: "三区：万亩优质荔枝绿色生产区",
            tc_pic: "ico_line.png",
            tc_quote_template: "companyDrawer",
            tc_request_url: "",
            tc_status: 1,
            tc_template: "companyDrawer",
            tc_type: "point",
            type: "polygon"
          }
        ]
      };

      data.data.map(ele => {
        if (ele.img === "zxd.png") {
          this.pointList.push(ele);
        } else if (ele.tc_name.indexOf("多基地") > -1) {
          this.baseList.push(ele);
        } else {
          this.areaList.push(ele);
        }
      });
      //   this.getMMLZDPZHWL();
      this.pointLoad();
      this.areaLoad();
      this.baseLoad();
      this.beltLoad();
    },

    //智慧物联点列表
    getMMLZDPZHWL() {
      getMMLZDPZHWL().then(res => {
        if (res.code == 200) {
          this.zhwlList = res.data;
        }
      });
    },
    //两区数据加载
    areaLoad1() {
      if (this.areaLayer) {
        this.map.removeLayer(this.areaLayer);
      }
      this.areaLayer = new L.layerGroup();
      if (this.areaList.length > 0) {
        for (let i = 0, len = this.areaList.length; i < len; i++) {
          let lineUrl = require("images/index/map/line_map.png");
          let pointUrl = require("images/index/map/" + this.areaList[i].tc_pic);
          let aPoint = new changeMap(
            this.areaList[i].latitude,
            this.areaList[i].longitude
          );
          this.$set(this.areaList[i], "lat", aPoint.lat);
          this.$set(this.areaList[i], "lng", aPoint.lng);
          let myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><div style='display:flex'><img src='" +
              pointUrl +
              "' /></div><div class='ztgh1-div-" +
              this.areaList[i].tc_leftRight +
              "'><img class='Img" +
              this.areaList[i].tc_leftRight +
              "' src='" +
              lineUrl +
              "'/><span class='ztgh-div-names'>" +
              this.areaList[i].name +
              "</span ></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [30, 50]
          });
          let areaPointLayer = L.marker(
            [this.areaList[i].lat, this.areaList[i].lng],
            {
              icon: myIcons,
              attributes: this.areaList[i]
            }
          ).addTo(this.areaLayer);
          areaPointLayer.on("click", e => {
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
        this.map.addLayer(this.areaLayer);
      }
    },
    //两区数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: this.areaList[i]
        }).addTo(this.map);
      }
      this.areaLoad1();
    },
    //科技中心数据加载
    pointLoad() {
      this.kjArr = [];
      console.log("pointList", this.pointList);
      this.pointList.map(it => {
        if (this.pointLayer) {
          this.map.removeLayer(this.pointLayer);
        }
        if (it.latitude) {
          let aPoint = new changeMap(it.latitude, it.longitude);
          it.lat = aPoint.lat;
          it.lng = aPoint.lng;
          let lineUrl = require("images/index/map/line_map.png");
          let pointUrl = require("images/index/map/" + it.tc_pic + ".png");
          let pointIcon = L.divIcon({
            html:
              "<div class='indicator-box'><div style='display:flex'><img style='width:50px' src='" +
              pointUrl +
              "' /></div><div class='zxd-div-" +
              it.tc_leftRight +
              "'><img class='Img" +
              it.tc_leftRight +
              "' src='" +
              lineUrl +
              "'/><span class='ztgh-div-names'>" +
              it.name +
              "</span ></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: this.pointAnchor
          });

          this.pointLayer = L.marker([it.lat, it.lng], {
            icon: pointIcon,
            attributes: it
          }).addTo(this.map);
          this.kjArr.push(this.pointLayer);
          this.pointLayer.on("click", e => {
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
    },

    //多基地数据加载
    baseLoad() {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      this.baseList.map(it => {
        if (it.latitude) {
          let aPoint = new changeMap(it.latitude, it.longitude);
          it.lat = aPoint.lat;
          it.lng = aPoint.lng;
          let pointUrl = require("images/index/map/" + it.tc_pic + ".png");
          let lineUrl = require("images/index/map/line_map.png");
          var myIcons;
          if (it.tc_pic === "ico_sf") {
            myIcons = L.divIcon({
              html:
                "<div class='indicator-box sLine ico_sf'><div class='ztgh-div-box'><img class='ztgh-div-image " +
                it.tc_pic +
                "' src='" +
                pointUrl +
                "'/><div class='ztgh-div-text mys-div-s'><span class='ztgh-div-name'>" +
                it.name +
                "</span></div></div></div>",
              className: "ztgh-div-icon",
              iconAnchor: this.djd
            });
          } else {
            myIcons = L.divIcon({
              html:
                "<div class='indicator-box ico_sf'><div style='display:flex'><img src='" +
                pointUrl +
                "' /></div><div class='ztgh-div-" +
                it.tc_leftRight +
                "'><img class='Img" +
                it.tc_leftRight +
                "' src='" +
                lineUrl +
                "'/><span class='ztgh-div-names'>" +
                it.name +
                "</span ></div></div>",
              className: "ztgh-div-icon",
              iconAnchor: this.djd
            });
          }
          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.basesGroup);
          baseLayer.on("click", e => {
            e;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   e.sourceTarget.options.attributes
            // );
            // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
    },
    //联动发展带数据加载
    beltLoad() {
      this.ydArr = [];
      if (this.beltGroup) {
        this.map.removeLayer(this.beltGroup);
      }
      this.beltGroup = new L.layerGroup();
      if (this.ydGroup) {
        this.map.removeLayer(this.ydGroup);
      }
      this.ydGroup = new L.layerGroup();
      this.beltObj = {
        area: 80000,
        code: "0599",
        config: [
          [111.00207344931157, 21.40824081949592],
          [111.0299984091313, 21.41846526547389],
          [111.03399984091313, 21.43338434605539],
          [111.04099984091313, 21.45338434605539],
          [111.04899984091313, 21.46738434605539],
          [111.05499984091313, 21.48538434605539],
          [111.06221224325685, 21.509377589354633],
          [111.07021224325685, 21.529377589354633],
          [111.07621224325685, 21.549377589354633],
          [111.08251192587401, 21.569645929394305],
          [111.08319857138182, 21.588571767164977],
          [111.08219857138182, 21.607571767164977],
          [111.08363179892087, 21.626000609173064],
          [111.08563179892087, 21.646000609173064],
          [111.08619857138182, 21.668573276341478],
          [111.08619857138182, 21.688573276341478],
          [111.09219857138182, 21.708573276341478],
          [111.09057186239743, 21.73034283273087],
          [111.09457186239743, 21.75034283273087],
          [111.09557186239743, 21.77034283273087],
          [111.09557186239743, 21.79034283273087],
          [111.09721990145578, 21.813540984445294],
          [111.10021990145578, 21.83852889525281],
          [111.11038079012766, 21.855290262890175],
          [111.09038079012766, 21.875290262890175]
        ],
        desc:
          '<p><span style="font-family: 宋体, SimSun; color: rgb(255, 255, 255); font-size: 12px;">联结包茂高速沿线资源，发挥产业园要素集聚和综合服务优势，成为吸聚高端要素、汇集优秀人才、实现产业高质量发展的中枢发展带。按照休闲农旅融合的方向，以荔枝规模化种植基地为核心要素，整合荔枝贡园、红荔阁、浮山岭、鳄人谷等自然旅游景点，将荔枝绿色高效种植、现代化加工、观光旅游、文化科普等有机串联，形成“一产接二连三”的互动型、融合型发展模式，开发休闲农文旅观光精品旅游线路，打造凸显荔枝优势特色产业集聚、浓郁文化体验、独特民俗风情的休闲农旅融合发展带。</span></p>',
        grade: 3,
        img: "ico_line",
        latitude: "",
        longitude: "",
        name: "荔枝产业集聚与农旅融合发展带",
        tc_color: null,
        tc_id: "0207ee442af14b278dedf9ade66bbc09",
        tc_leftRight: "right",
        tc_name: "一带：荔枝产业集聚与农旅融合发展带",
        tc_pic: "ico_yd.png",
        tc_quote_template: "companyDrawer",
        tc_request_url: "",
        tc_status: 1,
        tc_template: "companyDrawer",
        tc_type: "points",
        type: "points"
      };
      let beltObj = this.beltObj;
      let beltPoints = beltObj.config;
      for (let i = 0, len = beltPoints.length; i < len; i++) {
        let aPoint = new changeMap(beltPoints[i][1], beltPoints[i][0]);
        let iconSize, iconAnchor;
        if (i === 24) {
          iconSize = [40, 40];
          iconAnchor = this.ydwAnchor;
        } else if (i === 0) {
          iconAnchor = this.ydtAnchor;
        } else {
          iconAnchor = this.ydAnchor;
        }
        let ydIcon = L.icon({
          iconUrl: require("images/index/map/jt/" + i + ".png"),
          iconSize: iconSize,
          iconAnchor: iconAnchor,
          popupAnchor: [0, 0]
        });
        let ydData = L.marker([aPoint.lat, aPoint.lng], {
          icon: ydIcon,
          attributes: beltObj,
          interactive: true
        }).addTo(this.beltGroup);
        if (i === 4) {
          let lineUrl = require("images/index/map/line_map.png");
          let pointUrl = require("images/index/map/point.png");
          let pointIcon = L.divIcon({
            html:
              "<div class='indicator-box'><div style='display:flex'><img style='position:absolute;top:23px;left:18px' src='" +
              pointUrl +
              "' /></div><div class='ztgh-div-" +
              beltObj.tc_leftRight +
              "'><img class='Img" +
              beltObj.tc_leftRight +
              "' src='" +
              lineUrl +
              "'/><span class='ztgh-div-names'>" +
              beltObj.name +
              "</span ></div></div>",
            className: "ztgh-div-icon",
            iconAnchor: [30, 50]
          });
          let ydd = L.marker([aPoint.lat, aPoint.lng], {
            icon: pointIcon,
            attributes: beltObj
          }).addTo(this.ydGroup);
          ydd.on("click", e => {
            this.$store.dispatch(
              "drawer/setGraphic",
              e.sourceTarget.options.attributes
            );
            this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
          });
        }
        ydData.on("click", e => {
          this.$store.dispatch(
            "drawer/setGraphic",
            e.sourceTarget.options.attributes
          );
          this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
        });
      }
      this.map.addLayer(this.beltGroup);
      this.map.addLayer(this.ydGroup);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="stylus" scoped>
.map
  background none !important
  width 100%
  height calc(100% + 105px)
  z-index 9
  // >>>.leaflet-tile-pane
  // display none
  >>>.leaflet-bar
    display none
  >>>.leaflet-bottom
    display none
  .ncDetail
    position absolute
</style>
<style lang="stylus">
.ztgh-div-icon
  color #fff
  z-index 970 !important
.indicator-box
  position relative
.ztgh-div-image
  position relative
  width 0.1rem
  height 0.1rem
.ico_sf
  width 0.6rem
  height 0.6rem
.ztgh-div-text
  position absolute
  width 1.3rem
  height 30px
  display flex
  justify-content center
  align-items center
.mys-div-right
  top -18px
  left -0.2rem
  text-align center
.mys-div-left
  text-align center
  top -18px
  right 0.25rem
.ztgh-div-name
  font-size 0.08rem
  border 1px #fff solid
  border-radius 5px
  background-color rgba(15, 62, 112, 0.8)
  padding 2px 8px
.ztgh-div-name:hover
  z-index 999
  font-size 0.09rem
.ztgh-div-names
  font-size 0.08rem
  color #FFF
  position absolute
  width 1.2rem
  text-shadow -1px 0 #FF770C, 0 1px #FF770C, 1px 0 #FF770C, 0 -1px #FF770C
.ztgh-div-names:hover
  z-index 999
  font-size 0.09rem
.sLine
  transform translate(-50%, -50%)
.mys-div-s
  top -25px
  left -0.35rem
  text-align center
img
  display inline-block
.ztgh1-div-left
  position absolute
  top -15px
  right 0
  img
    width 100px
  span
   text-align right
   position absolute
   right 100px
   top -11px
.ztgh1-div-right
  transform rotateY(180deg)
  position absolute
  top -16px
  left 7px
  img
    width 100px
  span
   transform rotateY(-180deg)
   position absolute
   right 100px
   top -11px
.ztgh-div-left
  position absolute
  top -15px
  right 0
  img
    width 100px
  span
   text-align right
   position absolute
   right 100px
   top -11px
.ztgh-div-right
  transform rotateY(180deg)
  position absolute
  top 6px
  left 24px
  img
    width 100px
  span
   transform rotateY(-180deg)
   position absolute
   right 100px
   top -11px
.zxd-div-right
  transform rotateY(180deg)
  position absolute
  top -9px
  left 18px
  img
    width 100px
  span
   transform rotateY(-180deg)
   position absolute
   right 100px
   top -11px
@media (max-width 1280px)
  .mapDiv
    transform scale(0.75)
</style>
